import { createAction } from "redux-actions";

export const setBlock = createAction('SET_BLOCK');
